var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 13.4583C4.25 14.2375 4.8875 14.875 5.66667 14.875H11.3333C12.1125 14.875 12.75 14.2375 12.75 13.4583V6.375C12.75 5.59583 12.1125 4.95833 11.3333 4.95833H5.66667C4.8875 4.95833 4.25 5.59583 4.25 6.375V13.4583ZM6.375 6.375H10.625C11.0146 6.375 11.3333 6.69375 11.3333 7.08333V12.75C11.3333 13.1396 11.0146 13.4583 10.625 13.4583H6.375C5.98542 13.4583 5.66667 13.1396 5.66667 12.75V7.08333C5.66667 6.69375 5.98542 6.375 6.375 6.375ZM10.9792 2.83333L10.4763 2.33042C10.3488 2.20292 10.1646 2.125 9.98042 2.125H7.01958C6.83542 2.125 6.65125 2.20292 6.52375 2.33042L6.02083 2.83333H4.25C3.86042 2.83333 3.54167 3.15208 3.54167 3.54167C3.54167 3.93125 3.86042 4.25 4.25 4.25H12.75C13.1396 4.25 13.4583 3.93125 13.4583 3.54167C13.4583 3.15208 13.1396 2.83333 12.75 2.83333H10.9792Z",
    fill: "#CDCEC8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.485095d8.svg";
export { ForwardRef as ReactComponent };